import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class LaborManagement_ds_get_work_classes_by_operationCodeIdsService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { operationCodeIds: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, OperationCodes?: { Id?: number, Priority?: number, OperationCode?: { Id?: number, Name?: string } }[], EquipmentTypes?: { Id?: number, EquipmentType?: { Id?: number, LookupCode?: string } }[], Zones?: { Id?: number }[], AssignmentListForWorkClass?: { UserId?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationCodeIds)) {
      missingRequiredInParams.push('\'operationCodeIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_classes_by_operationCodeIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { operationCodeIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, OperationCodes?: { Id?: number, Priority?: number, OperationCode?: { Id?: number, Name?: string } }[], EquipmentTypes?: { Id?: number, EquipmentType?: { Id?: number, LookupCode?: string } }[], Zones?: { Id?: number }[], AssignmentListForWorkClass?: { UserId?: string }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationCodeIds)) {
      missingRequiredInParams.push('\'operationCodeIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_classes_by_operationCodeIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { operationCodeIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Description?: string, LookupCode?: string, Name?: string, OperationCodes?: { Id?: number, Priority?: number, OperationCode?: { Id?: number, Name?: string } }[], EquipmentTypes?: { Id?: number, EquipmentType?: { Id?: number, LookupCode?: string } }[], Zones?: { Id?: number }[], AssignmentListForWorkClass?: { UserId?: string }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.operationCodeIds)) {
      missingRequiredInParams.push('\'operationCodeIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/LaborManagement/datasources/ds_get_work_classes_by_operationCodeIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      operationCodeIds: number[]    }) {
        if(isNil(inParams.operationCodeIds)) {
          return true; 
        }
      return false;
    }
}
